// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__8tTEw","selected":"Chip_selected__knjjJ"};